import { useOrderQuery } from '@/hooks/queries/use-order-query';
import Row from './Row';
import { OrderPaymentStatus } from '@/types/api/order/order-payment-status.enum';
import { useParams } from 'react-router-dom';
import { formatMobileNumber } from '@/utils/Utils';
import { Loader } from '../ui/loader';

export default function Table() {
  const { orderId } = useParams();
  const { data: order, isLoading, error } = useOrderQuery(orderId!);

  if (error) throw error;

  if (isLoading) return <Loader />;

  if (!order) return null;

  return (
    <div className="space-y-4 sm:space-y-2 rounded-lg border border-gray-100 bg-gray-50 p-6 dark:border-gray-700 dark:bg-gray-800 mb-6 md:mb-8">
      <div className="font-semibold text-lg">Din beställning</div>
      <Row label="Datum" value={new Date(order.createdAt).toLocaleDateString('se')} />
      <Row
        label="Betalningsstatus"
        value={order.paymentStatus === OrderPaymentStatus.Paid ? 'Betald' : 'Betalas vid leverans'}
      />
      <Row label="Namn" value={`${order.customer?.firstName} ${order.customer?.lastName}`} />
      <Row
        label="Adress"
        value={`${order.shippingAddress?.street}, ${order.shippingAddress?.postalCode} ${order.shippingAddress?.city}`}
      />
      <Row label="E-post" value={order.customer?.email!} />
      <Row label="Mobilnummer" value={formatMobileNumber(order.customer?.mobileNumber!)!} />
      <div className="font-semibold text-lg">Säljaren</div>
      <Row label="Namn" value={`${order.user?.firstName} ${order.user?.lastName}`} />
      <Row label="E-post" value={order.user?.email!} />
      <Row label="Mobilnummer" value={formatMobileNumber(order.user?.mobileNumber!)!} />
      <Row label="Grupp" value={`${order.group?.groupName}, ${order.group?.organizationName}`} />
    </div>
  );
}
